import { Step } from './Steps';

export enum StepEvent {
  NEXT = 'NEXT',
  BACK = 'BACK',
}
export const transitionLocataire = (currentStep: Step, event: StepEvent): Step => {
  switch (currentStep) {
    case Step.LOGEMENT: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.CREDITS;
        case StepEvent.BACK:
          return Step.LOGEMENT;
        default:
          return currentStep;
      }
    }
    case Step.CREDITS: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.NOUVEAUPROJECT;
        case StepEvent.BACK:
          return Step.LOGEMENT;
        default:
          return currentStep;
      }
    }
    case Step.NOUVEAUPROJECT: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.IDENTITE;
        case StepEvent.BACK:
          return Step.CREDITS;
        default:
          return currentStep;
      }
    }
    case Step.IDENTITE: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.NATIONALITE;
        case StepEvent.BACK:
          return Step.NOUVEAUPROJECT;
        default:
          return currentStep;
      }
    }
    case Step.NATIONALITE: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.NAISSANCE;
        case StepEvent.BACK:
          return Step.IDENTITE;
        default:
          return currentStep;
      }
    }
    case Step.NAISSANCE: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.SITUATIONFAMILIALE;
        case StepEvent.BACK:
          return Step.NATIONALITE;
        default:
          return currentStep;
      }
    }
    case Step.SITUATIONFAMILIALE: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.SITUATIONPRO;
        case StepEvent.BACK:
          return Step.NAISSANCE;
        default:
          return currentStep;
      }
    }
    case Step.SITUATIONPRO: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.REVENUS;
        case StepEvent.BACK:
          return Step.SITUATIONFAMILIALE;
        default:
          return currentStep;
      }
    }
    case Step.REVENUS: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.DEPENSES;
        case StepEvent.BACK:
          return Step.SITUATIONPRO;
        default:
          return currentStep;
      }
    }
    case Step.DEPENSES: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.CONTACT;
        case StepEvent.BACK:
          return Step.REVENUS;
        default:
          return currentStep;
      }
    }
    case Step.CONTACT: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.ADRESSE;
        case StepEvent.BACK:
          return Step.DEPENSES;
        default:
          return currentStep;
      }
    }
    case Step.ADRESSE: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.RECAPITULATIF;
        case StepEvent.BACK:
          return Step.CONTACT;
        default:
          return currentStep;
      }
    }
    case Step.RECAPITULATIF: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.RESPONSE;
        case StepEvent.BACK:
          return Step.ADRESSE;
        default:
          return currentStep;
      }
    }
    // case Step.RECAP: {
    //   switch (event) {
    //     case StepEvent.NEXT:
    //       return Step.RESPONSE;
    //     case StepEvent.BACK:
    //       return Step.ADRESSE;
    //     default:
    //       return currentStep;
    //   }
    // }

    default:
      return currentStep;
  }
};
export const transition = (currentStep: Step, event: StepEvent): Step => {
  switch (currentStep) {
    case Step.LOGEMENT: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.CREDITS;
        case StepEvent.BACK:
          return Step.LOGEMENT;
        default:
          return currentStep;
      }
    }
    case Step.CREDITS: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.NOUVEAUPROJECT;
        case StepEvent.BACK:
          return Step.LOGEMENT;
        default:
          return currentStep;
      }
    }
    case Step.NOUVEAUPROJECT: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.IDENTITE;
        case StepEvent.BACK:
          return Step.CREDITS;
        default:
          return currentStep;
      }
    }
    case Step.IDENTITE: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.NATIONALITE;
        case StepEvent.BACK:
          return Step.NOUVEAUPROJECT;
        default:
          return currentStep;
      }
    }
    case Step.NATIONALITE: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.NAISSANCE;
        case StepEvent.BACK:
          return Step.IDENTITE;
        default:
          return currentStep;
      }
    }
    case Step.NAISSANCE: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.SITUATIONFAMILIALE;
        case StepEvent.BACK:
          return Step.NATIONALITE;
        default:
          return currentStep;
      }
    }
    case Step.SITUATIONFAMILIALE: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.SITUATIONPRO;
        case StepEvent.BACK:
          return Step.NAISSANCE;
        default:
          return currentStep;
      }
    }
    case Step.SITUATIONPRO: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.REVENUS;
        case StepEvent.BACK:
          return Step.SITUATIONFAMILIALE;
        default:
          return currentStep;
      }
    }
    case Step.REVENUS: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.CONTACT;
        case StepEvent.BACK:
          return Step.SITUATIONPRO;
        default:
          return currentStep;
      }
    }
    case Step.CONTACT: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.ADRESSE;
        case StepEvent.BACK:
          return Step.REVENUS;
        default:
          return currentStep;
      }
    }
    case Step.ADRESSE: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.RECAPITULATIF;
        case StepEvent.BACK:
          return Step.CONTACT;
        default:
          return currentStep;
      }
    }
    case Step.RECAPITULATIF: {
      switch (event) {
        case StepEvent.NEXT:
          return Step.RESPONSE;
        case StepEvent.BACK:
          return Step.ADRESSE;
        default:
          return currentStep;
      }
    }
    // case Step.RECAP: {
    //   switch (event) {
    //     case StepEvent.NEXT:
    //       return Step.RESPONSE;
    //     case StepEvent.BACK:
    //       return Step.ADRESSE;
    //     default:
    //       return currentStep;
    //   }
    // }

    default:
      return currentStep;
  }
};
